<template>
  <div class="drawer-box">
    <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose">
    <span slot="title" class="title">{{$t('complaintList.highSearch')}}</span>
    <div class="filter-box">
        <div class="row" v-for="(item, i) in filteredList" :key="i">
            <span class="label">{{item.name}}：</span>
            <div class="col">
             <el-input
              :placeholder="$t('loginUserlogin.pleChoice')+item.name"
              v-model="form[item.val]"
              class="input-with-select" v-if="item.type=='input'"
            />
                <el-select v-model="form[item.val]" :placeholder="$t('loginUserlogin.pleChoice')+item.name" v-if="(item.type!='time') && (item.type!='customer') && (item.type!='input') && (item.type!='fault')">
                    <el-option
                        v-for="v in fun(item.url)"
                        :key="v.id"
                        :label="item.label?v[item.label]:v"
                        :value="item.label?v[item.label]:v">
                    </el-option>
                </el-select>
                <el-select v-model="form[item.val]" :placeholder="$t('loginUserlogin.pleChoice')+item.name" v-if="(item.type=='customer') && (item.type!='input')">
                    <el-option
                        v-for="v in statusOptions"
                        :key="v.id"
                        :label="item.label?v[item.label]:v"
                        :value="item.optionVal?v[item.optionVal]:v">
                    </el-option>
                </el-select>

                <el-select v-model="form[item.val]" :placeholder="$t('loginUserlogin.pleChoice')+item.name" v-if="(item.type=='fault')&& (item.type!='input') &&(item.type!=='customer') ">
                    <el-option
                        v-for="v in faultOptions"
                        :key="v.id"
                        :label="item.label?v[item.label]:v"
                        :value="v.id">
                    </el-option>
                </el-select>
                <el-date-picker
                    v-if="item.type=='time'"
                    v-model="form[item.val]"
                    type="daterange"
                    range-separator="-"
                    :start-placeholder="$t('complaintList.startTime')"
                    :end-placeholder="$t('complaintList.endTime')">
                </el-date-picker>
            </div>
      </div>
    
    </div> 
    <div class="btns">
        <el-button class="cancel-btn" @click="result">{{$t('reportfilter.reset')}}</el-button>
        <el-button class="confirm-btn" @click="submit">{{$t('indexTags.sure')}}</el-button>
    </div>
    </el-drawer>
  </div>
</template>

<script>
import {searchurl} from "@/api/search"
import moment from 'moment'
  export default {
    props: {
      visible: { default: false },
      defaultList:{
        type:Array,
         default () {
            return []
        }
      },
      defaultInfo: { 
        default: () => {
            return {};
        }
      },
    },
    data() {
      return {
        direction: 'rtl',
        statusOptions: [
         {'name': this.$t('applyChild.all'),value: 0, id:1},{'name': this.$t('applyChild.applying'),value: 11, id:2},{'name': this.$t('setDeviceUnlockDetail.unlocked'),value: 12, id:3},{'name': this.$t('setDeviceUnlockDetail.unapplied'),value: 10, id:4}
      ],
       faultOptions: [
         {'name': this.$t('setDeviceUnlockDetail.cancelRepair'),value: 0, id:1},{'name': this.$t('complaintOrderDetail.toBeAccepted'),value: 1, id:2},{'name': this.$t('serviceChildDetail.toBeRepaired'),value: 2, id:3},{'name': this.$t('complaintOrderDetail.toBeSured'),value: 3, id:4},{'name': this.$t('complaintOrderDetail.completed'),value: 4, id:4}
      ],
        form: {
          
        },
        api: null,
        options:[],
        genoptions:[],
        areaoptions:[],
        codeoptions:[],
        bankoptions:[],
        tempOption:{}
      }
    },
    created() {
      this.getrequest()
       
  },
  computed: {
      roleType() {
        return this.website.roleType
      },
      filteredList() {
        // 假设要删除字段 type === 'xxx' 的项
        return this.defaultList.filter(item => item.isHide !== this.roleType)
      }
    },
    methods: {
      fun(info){
        return  eval(this.tempOption[info])    
      },
      getrequest(){
        this.filteredList.map(async v=>{
            if((v.type!='time') && (v.type!='customer') && (v.type!='type')){
                 await searchurl[v.url]().then(res=>{
                    // console.log(res,'--res')
                    //直接返回数据的处理 ['店铺', '区代', '总代', '机器', '服务', '价格', '其他']
                    if (Object.prototype.toString.call(res.data.data[0]) != '[object Object]') {
                      let temAry = []
                     temAry =  res.data.data.map(item=>{
                        return {[v.label] :item}
                      })
                      this.tempOption[v.url] = temAry;
                      // this[v.option] = temAry
                    } else {
                      this.tempOption[v.url] = res.data.data;
                      // this[v.option] = res.data.data
                    }
                    // console.log(this[v.option],'--this[v.option]')
                    
                })
            }
        })
      },
     
      handleClose() {
        this.$emit("close", false);
      },
      result(){
        this.form = {}
      },
      submit() {
        console.log(this.form)
        if(Array.isArray(this.form.timer)&&this.form.timer.length>0){
          this.form.beginTime = moment(this.form.timer[0]).format("YYYY-MM-DD")
          this.form.endTime = moment(this.form.timer[1]).format("YYYY-MM-DD")
        }else{
          this.form.beginTime =''
          this.form.endTime = ''
        }
        this.$emit("submit", this.form);
      },
      async getFilterList(type) {
       
      }
    }
  };
</script>

<style lang="scss" scoped>
/deep/ #el-drawer__title .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
}

.filter-box {
    position: relative;
    padding: 0 51px;
}

.row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.label {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    min-width: 15%;
}

.col {
    flex: 1;
}

.btns {
    position: absolute;
    left: 50%;
    bottom: 93px;
    transform: translate(-50%, 0);
    .cancel-btn {
        color: #50C4CB;
        border-color: #50C4CB;
    }
    .confirm-btn {
        background-color: #50C4CB;
        color: #fff;
    }
}
</style>